import { FunctionComponent } from 'react'
import { DatePicker, TextArea } from '../../shared'
import { ManualPrescriptionFormProps } from './ManualPrescriptionForm.model'
import styles from './ManualPrescriptionForm.module.scss'

export const ManualPrescriptionForm: FunctionComponent<ManualPrescriptionFormProps> = ({
  currentManualPrescription,
  onChange,
}) => {
  return (
    <div className={styles.manualPrescriptionFormContainer}>
      <TextArea
        name="prescriptionReason"
        placeholder="Motif de prescription"
        value={currentManualPrescription.content}
        onChange={({ target: { value } }) => {
          onChange({ content: value })
        }}
        initialRows={3}
        testId="textarea-drug-manual_prescription-reason-set"
        autoResize
      />
      <div className={styles.manualPrescriptionDatesContainer}>
        <div>
          <DatePicker
            label="Date de début"
            value={currentManualPrescription.startDate}
            onChange={(value) => {
              onChange({ startDate: value })
            }}
            colorPreset="light"
            inputType="input"
            testId="date_picker-drug-manual_prescription-start_date"
          />
        </div>
        <div>
          <DatePicker
            label="Date de fin"
            value={currentManualPrescription.endDate}
            onChange={(value) => {
              onChange({ endDate: value })
            }}
            colorPreset="light"
            inputType="input"
            validation={false}
            testId="date_picker-drug-manual_prescription-end"
          />
        </div>
      </div>
    </div>
  )
}
